import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import HomePage from '@Pages/HomePage';
import NotFoundPage from '@Pages/NotFoundPage';
import NewStudyPage from '@Pages/NewStudyPage';
import StudySummaryPage from '@Pages/StudySummaryPage';
import Layout from "./Layout";
import WellAnalysisPage from "@Pages/WellAnalysisPage";
import ListStudiesPage from "@Pages/ListStudiesPage";
import LoginPage from '@Pages/LoginPage';
import { useAuth } from '../contexts/AuthContext';
import PdfLayout from "./PdfLayout";
import { RED, WHITE } from '@Components/VerticeLogo';
const AppRouter = () => {
    const { isAuthenticated, loading } = useAuth();
    if (loading) {
        return _jsx("div", { children: "Loading..." }); // or a loading spinner
    }
    return (_jsx(Router, { children: _jsxs(Routes, { children: [_jsx(Route, { element: _jsx(PdfLayout, { logoColor: WHITE }), children: _jsx(Route, { path: "/", element: _jsx(HomePage, {}) }) }), _jsx(Route, { element: _jsx(Layout, { logoColor: RED }), children: _jsx(Route, { path: "/studies/:uuid", element: _jsx(StudySummaryPage, {}) }) }), _jsx(Route, { path: "/login", element: _jsx(LoginPage, {}) }), _jsxs(Route, { element: isAuthenticated ? _jsx(Layout, { logoColor: RED }) : _jsx(Navigate, { to: "/login" }), children: [_jsx(Route, { path: "/new-study", element: _jsx(NewStudyPage, {}) }), _jsx(Route, { path: "/studies", element: _jsx(ListStudiesPage, {}) })] }), _jsx(Route, { element: _jsx(PdfLayout, {}), children: _jsx(Route, { path: "/studies/:studyUuid/api/:wellApi", element: _jsx(WellAnalysisPage, {}) }) }), _jsx(Route, { path: "*", element: _jsx(NotFoundPage, {}) })] }) }));
};
export default AppRouter;
